import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { SwapDetailsImpl } from "../model/impl/SwapDetailsImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class SwapDetailsImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: SwapDetailsImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        SwapDetailsImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.swpSettleTenor != null) {
      this.baseEncoder.writeStartFid(941, streamout);
      this.baseEncoder.writeObject(
        false,
        SwapDetailsImplEncoder.fidTypeMap.get(941),
        false,
        encodable.swpSettleTenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(941, streamout);
    }
    /*Object encoding*/
    if (encodable.swpSettleDate != null) {
      this.baseEncoder.writeStartFid(942, streamout);
      this.baseEncoder.writeObject(
        false,
        SwapDetailsImplEncoder.fidTypeMap.get(942),
        false,
        encodable.swpSettleDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(942, streamout);
    }
    /*Object encoding*/
    if (encodable.swapPoints != null) {
      this.baseEncoder.writeStartFid(944, streamout);
      this.baseEncoder.writeObject(
        false,
        SwapDetailsImplEncoder.fidTypeMap.get(944),
        false,
        encodable.swapPoints,
        streamout,
      );
      this.baseEncoder.writeEndFid(944, streamout);
    }
    /*Object encoding*/
    if (encodable.orderQty != null) {
      this.baseEncoder.writeStartFid(945, streamout);
      this.baseEncoder.writeObject(
        false,
        SwapDetailsImplEncoder.fidTypeMap.get(945),
        false,
        encodable.orderQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(945, streamout);
    }
    /*Object encoding*/
    if (encodable.settleQty != null) {
      this.baseEncoder.writeStartFid(946, streamout);
      this.baseEncoder.writeObject(
        false,
        SwapDetailsImplEncoder.fidTypeMap.get(946),
        false,
        encodable.settleQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(946, streamout);
    }
    /*Object encoding*/
    if (encodable.leavesQty != null) {
      this.baseEncoder.writeStartFid(947, streamout);
      this.baseEncoder.writeObject(
        false,
        SwapDetailsImplEncoder.fidTypeMap.get(947),
        false,
        encodable.leavesQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(947, streamout);
    }
    /*Object encoding*/
    if (encodable.leavesSettleQty != null) {
      this.baseEncoder.writeStartFid(948, streamout);
      this.baseEncoder.writeObject(
        false,
        SwapDetailsImplEncoder.fidTypeMap.get(948),
        false,
        encodable.leavesSettleQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(948, streamout);
    }
    /*Object encoding*/
    if (encodable.usdEquivQty != null) {
      this.baseEncoder.writeStartFid(949, streamout);
      this.baseEncoder.writeObject(
        false,
        SwapDetailsImplEncoder.fidTypeMap.get(949),
        false,
        encodable.usdEquivQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(949, streamout);
    }
    /*Object encoding*/
    if (encodable.usdEquivLeavesQty != null) {
      this.baseEncoder.writeStartFid(950, streamout);
      this.baseEncoder.writeObject(
        false,
        SwapDetailsImplEncoder.fidTypeMap.get(950),
        false,
        encodable.usdEquivLeavesQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(950, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,SwapDetailsImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [941, "com.bcdfx.model.Tenor"],
    [942, "java.util.Date"],
    [944, "java.math.BigDecimal"],
    [945, "java.math.BigDecimal"],
    [946, "java.math.BigDecimal"],
    [947, "java.math.BigDecimal"],
    [948, "java.math.BigDecimal"],
    [949, "java.math.BigDecimal"],
    [950, "java.math.BigDecimal"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: SwapDetailsImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            SwapDetailsImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 941: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            SwapDetailsImplEncoder.fidTypeMap.get(941),
            streamin,
          );
          encodable.swpSettleTenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 942: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            SwapDetailsImplEncoder.fidTypeMap.get(942),
            streamin,
          );
          encodable.swpSettleDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 944: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            SwapDetailsImplEncoder.fidTypeMap.get(944),
            streamin,
          );
          encodable.swapPoints = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 945: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            SwapDetailsImplEncoder.fidTypeMap.get(945),
            streamin,
          );
          encodable.orderQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 946: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            SwapDetailsImplEncoder.fidTypeMap.get(946),
            streamin,
          );
          encodable.settleQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 947: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            SwapDetailsImplEncoder.fidTypeMap.get(947),
            streamin,
          );
          encodable.leavesQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 948: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            SwapDetailsImplEncoder.fidTypeMap.get(948),
            streamin,
          );
          encodable.leavesSettleQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 949: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            SwapDetailsImplEncoder.fidTypeMap.get(949),
            streamin,
          );
          encodable.usdEquivQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 950: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            SwapDetailsImplEncoder.fidTypeMap.get(950),
            streamin,
          );
          encodable.usdEquivLeavesQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,SwapDetailsImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return SwapDetailsImplEncoder.fidTypeMap.has(fid);
  }
}
